module.exports = __webpack_public_path__ + "static/media/image8.b0ac413f.png";